export default __webpack_public_path__ + "static/media/flag_orange.569231b6.svg";